import React from 'react'

export default function HowWorkCard({text}) {
  return (
    <div className="flex space-x-2 my-2 py-6 text-white items-center sm:space-x-4 bg-primary rounded-md shadow-lg">
   <div className='bg-white relative right-[3%] rounded-full p-2'>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="#3056D3" className="flex-shrink-0 w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"></path>
    </svg>

   </div>
    <div className="space-y-2 pr-5">
        
        <p className="leadi">{text}
</p>
    </div>
</div>
  )
}
